import { FC, ReactNode, useEffect } from 'react'
import { ConfirmationState } from '@/states'
import { Translation } from '@/helpers'
import { InformationCircleIcon, XMarkIcon } from '@heroicons/react/16/solid'

const Confirmation: FC = (): ReactNode => {
    const { Title, Open, SetState, onConfirm } = ConfirmationState()

    useEffect(() => {
        if (Open) {
            document.body.style.overflow = 'hidden'
            document.body.style.userSelect = 'none'
        }

        else {
            document.body.style.overflow = 'unset'
            document.body.style.userSelect = 'unset'
        }
    }, [Open])

    const Close = () => SetState({ Open: false })

    useEffect(() => {
        const KeyPress = (e: KeyboardEvent) => {
            if (e.key === 'Escape' && Open) Close()
            if (e.key === 'Enter' && Open) onConfirm()
        }

        document.addEventListener('keydown', KeyPress)
        return () => document.removeEventListener('keydown', KeyPress)
    }, [Open])

    if (Open) return (
        <div onClick={Close} className='select-none fixed top-0 left-0 bg-[#181818b5] right-0 p-4overflow-x-hidden overflow-y-auto md:inset-0 h-full flex justify-center items-center z-[99999999]'>
            <div className='relative bg-red w-full max-w-md max-h-full'>
                <div onClick={(e) => e.stopPropagation()} className='relative bg-[#262626] rounded-md'>
                    <button onClick={Close} className='absolute top-3 right-2.5 bg-[#404040] hover:opacity-75 rounded-md text-sm p-[5px] ml-auto inline-flex items-center transition-all duration-500 ease-in-out select-none'>
                        <XMarkIcon className='w-4 h-4 text-[#EBEBEB]' />
                    </button>

                    <div className='p-6 pb-4 text-center'>
                        <div className='w-full flex justify-center items-center align-middle'>
                            <InformationCircleIcon className='w-8 h-8 text-[#EBEBEB]' />
                        </div>

                        <h3 className='mb-5 mt-2 text-m font-bold text-xl text-[#EBEBEB]'>
                            {Title}
                        </h3>

                        <section className='w-full flex justify-center gap-2 items-center'>
                            <button onClick={Close} className='flex bg-[#404040] items-center justify-center w-full px-2.5 py-1.5 text-sm font-medium text-[#EBEBEB] rounded-md md:w-auto hover:opacity-70 transition-all ease-in-out duration-500'>
                                {Translation('cancel')}
                            </button>

                            <button onClick={onConfirm} className='flex button-gradient items-center justify-center w-full px-2.5 py-1.5 text-sm font-medium rounded-md md:w-auto hover:opacity-90 text-[#EBEBEB] transition-all ease-in-out duration-500'>
                                {Translation('confirm')}
                            </button>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Confirmation
